import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TimeService {

    constructor() { }

    checkDate(trendingDate: Date, currentDate: Date, minutes: number): boolean {
        return this.isSameDay(trendingDate, currentDate) &&
            this.maxMinutes(trendingDate, currentDate, minutes);
    }

    isSameDay(trendingDate: Date, currentDate: Date): boolean {
        return currentDate.getDay() == trendingDate.getDay() &&
            currentDate.getMonth() == trendingDate.getMonth();
    }

    isSameHour(trendingDate: Date, currentDate: Date): boolean {
        return currentDate.getHours() == trendingDate.getHours();
    }

    isOnlyOneHour(trendingDate: Date, currentDate: Date): boolean {
        return currentDate.getHours() - 1 == trendingDate.getHours();
    }

    maxMinutes(trendingDate: Date, currentDate: Date, minutes: number): boolean {
        if (this.isSameHour(trendingDate, currentDate)) {
            return currentDate.getMinutes() - trendingDate.getMinutes() < minutes;
        } else if (this.isOnlyOneHour(trendingDate, currentDate)) {
            return trendingDate.getMinutes() >= (60 - minutes) &&
                currentDate.getMinutes() <= (minutes - (60 - currentDate.getMinutes()));
        }
        return false;
    }
}
